/* eslint-disable @typescript-eslint/no-unused-vars */
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { copyAsset } from 'src/api/stoApi';

interface Props {
  assetId: string;
  open: boolean;
  handleClose: () => void;
  triggerRefresh: () => void;
}

export const CopyDialog: FC<Props> = ({ assetId, open, triggerRefresh, handleClose }) => {
  const { t } = useTranslation();
  const [dialogState, setDialogState] = useState<'init' | 'error' | 'success'>('init');
  const [error, setError] = useState<string>('');
  const [days] = useState<string>('35');
  const [isLoading, setLoading] = useState(false);
  console.log(error);
  const handleCloseAndReset = () => {
    handleClose();
    setDialogState('init');
    setError('');
  };

  return (
    <Dialog open={open} onClose={handleCloseAndReset}>
      {dialogState === 'init' && (
        <>
          <DialogTitle>{t('dashboard.assets.dialog.copy.title')}</DialogTitle>
          <DialogContent>
            <Typography>{t('dashboard.assets.dialog.copy.body')}</Typography>
          </DialogContent>
          <DialogActions>
            <Button color="inherit" onClick={handleCloseAndReset}>
              {t('dashboard.assets.dialog.copy.cancel')}
            </Button>
            <LoadingButton
              loading={isLoading}
              variant="contained"
              disableElevation
              color="primary"
              onClick={async () => {
                setLoading(true);
                try {
                  const changeStatus = await copyAsset(assetId);
                  if (changeStatus.data.status === 200) {
                    setDialogState('success');
                    triggerRefresh();
                  } else {
                    setDialogState('error');
                    setError(changeStatus.data.message);
                  }
                } catch (error: any) {
                  setDialogState('error');
                } finally {
                  setLoading(false);
                }
              }}
            >
              {t('dashboard.assets.dialog.copy.confirm')}
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
